<input
  #htmlTypeaheadElement
  #instance="ngbTypeahead"
  id="currency"
  class="form-control flex-fill me-2 mb-3"
  [placeholder]="
    placeholder ||
    ('serviceData.financeDetails.placeholders.currency' | translate)
  "
  container="body"
  [ngbTypeahead]="searchCurrencies"
  (focus)="focus$.next($event.target.value)"
  (click)="click$.next($event.target.value)"
  (selectItem)="selectItem($event)"
/>
